import { Capacitor } from "@capacitor/core";
import { Directory, Encoding, Filesystem } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";
import { showErrorMessage, showWarningMessage } from "helpers/toastMessage";

const SHARE_CANCELED_MESSAGE = "Share canceled";

// HP-9360: a blob link with `download` is a silent no-op in the Capacitor Android WebView, so on
// native the CSV is written to the app cache and handed to the share sheet instead.
export default async function saveCsvFile(content: string, filename: string) {
  if (Capacitor.isNativePlatform()) {
    try {
      const { uri } = await Filesystem.writeFile({
        path: filename,
        data: content,
        directory: Directory.Cache,
        encoding: Encoding.UTF8
      });
      await Share.share({ title: filename, files: [uri] });
    } catch (error) {
      if (error instanceof Error && error.message === SHARE_CANCELED_MESSAGE) {
        showWarningMessage(`${filename} was not saved.`);
      } else {
        showErrorMessage(`Couldn't save ${filename}. Please try again.`);
      }
    }
    return;
  }

  const blob = new Blob([content], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
